import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";

import DataTable from "react-data-table-component";
import { customTableStyles } from "../../utils";
import { Button, Form } from "react-bootstrap";
import EditCompanyModal from './edit';
import AddCompanyModal from './Add';
import ViewModal from './View';
const CompaniesPage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isView, setIsView] = useState(false)
    const columns = [
        {
            name: 'Company Name',
            selector: row => row.companyName,
            sortable: true,
        },
        {
            name: 'User First Name',
            selector: row => row.userFirstName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Phone',
            selector: row => row.phone,
            sortable: true,
        },
        {
            name: 'Country',
            selector: row => row.country,
            sortable: true,
        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: true,
        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: true,
        },
        {
            name: 'Status',
            cell: (row) => (
                <Form.Check
                    type="switch"
                    id={`status-switch-${row.id}`}  // Assuming each row has a unique ID for unique switch IDs
                    checked={row.status === 1}
                // onChange={() => handleStatusToggle(row)} // You can define this function to handle the status change
                />
            ),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row) => (
                <div className="hstack gap-1 fs-1">
                    <Button aria-label="View" className="btn btn-info-light">
                        <i className="ri-eye-line" />
                    </Button>
                    <Button aria-label="Edit" className="btn btn-info-light">
                        <i className="ri-edit-line" />
                    </Button>
                    <Button aria-label="Delete" className="btn btn-danger-light">
                        <i className="ri-delete-bin-7-line" />
                    </Button>
                </div>
            ),
            ignoreRowClick: true,
            // allowOverflow: true,
            // button: true,
        },
    ];
    const data = [
        {
            companyName: 'Company A',
            userFirstName: 'John',
            email: 'john@example.com',
            phone: '123-456-7890',
            country: 'Country A',
            city: 'City A',
            state: 'State A',
            status: 1,
        },
        {
            companyName: 'Company B',
            userFirstName: 'Jane',
            email: 'jane@example.com',
            phone: '987-654-3210',
            country: 'Country B',
            city: 'City B',
            state: 'State B',
            status: 0,
        },
        {
            companyName: 'Company C',
            userFirstName: 'Michael',
            email: 'michael@example.com',
            phone: '456-789-1234',
            country: 'Country C',
            city: 'City C',
            state: 'State C',
            status: 1,
        },
        {
            companyName: 'Company D',
            userFirstName: 'Sarah',
            email: 'sarah@example.com',
            phone: '321-654-9870',
            country: 'Country D',
            city: 'City D',
            state: 'State D',
            status: 0,
        },
        {
            companyName: 'Company E',
            userFirstName: 'David',
            email: 'david@example.com',
            phone: '789-123-4560',
            country: 'Country E',
            city: 'City E',
            state: 'State E',
            status: 1,
        },
        {
            companyName: 'Company F',
            userFirstName: 'Emily',
            email: 'emily@example.com',
            phone: '654-321-0987',
            country: 'Country F',
            city: 'City F',
            state: 'State F',
            status: 1,
        },
        {
            companyName: 'Company G',
            userFirstName: 'Robert',
            email: 'robert@example.com',
            phone: '234-567-8901',
            country: 'Country G',
            city: 'City G',
            state: 'State G',
            status: 0,
        },
        {
            companyName: 'Company H',
            userFirstName: 'Laura',
            email: 'laura@example.com',
            phone: '890-123-4567',
            country: 'Country H',
            city: 'City H',
            state: 'State H',
            status: 1,
        },
        {
            companyName: 'Company I',
            userFirstName: 'Daniel',
            email: 'daniel@example.com',
            phone: '567-890-1234',
            country: 'Country I',
            city: 'City I',
            state: 'State I',
            status: 0,
        },
        {
            companyName: 'Company J',
            userFirstName: 'Sophia',
            email: 'sophia@example.com',
            phone: '345-678-9012',
            country: 'Country J',
            city: 'City J',
            state: 'State J',
            status: 1,
        },
        {
            companyName: 'Company K',
            userFirstName: 'Henry',
            email: 'henry@example.com',
            phone: '678-901-2345',
            country: 'Country K',
            city: 'City K',
            state: 'State K',
            status: 0,
        },
        {
            companyName: 'Company L',
            userFirstName: 'Olivia',
            email: 'olivia@example.com',
            phone: '901-234-5678',
            country: 'Country L',
            city: 'City L',
            state: 'State L',
            status: 1,
        },
    ];

    // const data = [];

    return (
        <>
            <PageHeader name="Companies" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex">
                                        <Button className="btn btn-primary" onClick={() => setIsShow(true)}>
                                            Add Company
                                        </Button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                        <AddCompanyModal
                            show={isShow}
                            handleClose={() => setIsShow(false)}
                        />
                        <EditCompanyModal
                            show={isEdit}
                            handleClose={() => setIsEdit(false)}
                        />
                        <ViewModal
                            show={isView}
                            handleClose={() => setIsView(false)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompaniesPage;